export default __webpack_public_path__ + "static/3-5fafbdc73d478bb11f60715b1e3498a3.jpg";